export const REFRESH_TOKEN_KEY = 'refreshToken'
export const SELECTED_COMPANY_KEY = 'selectedCompany'
